import React from "react";
import { Col, Row } from "react-bootstrap";

function CheckoutSteps(props) {
  return (
    <div className="overflow-hidden">
      <div className="ml-md-2 mr-md-2">
        <Row className="checkout-steps">
          <Col xs={3} className={props.step1 ? "active" : ""}>Sign-In</Col>
          <Col xs={3} className={props.step2 ? "active" : ""}>Shipping</Col>
          <Col xs={3} className={props.step3 ? "active" : ""}>Payment</Col>
          <Col xs={3} className={props.step4 ? "active" : ""}>Place Order</Col>
        </Row>
      </div>
    </div>
  );
}

export default CheckoutSteps;
